module.exports = __webpack_public_path__ + "static/img/PLATINIUM 3.7bcffbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/New folder/PLATINIUM 3.jpg
// module id = IdFj
// module chunks = 1